<mat-card>
  <form [formGroup]="userForm" (ngSubmit)="submit()">
    <mat-card-header>
      <mat-card-title>
        <h4>
          <div *ngIf="editMode; else newUser">
            <span i18n>User</span>&nbsp;
            <span>{{ currentUsername }}</span>
          </div>
          <ng-template #newUser>
            <span i18n>New User</span>&nbsp;
          </ng-template>
        </h4>
      </mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div class="user-container">
        <div class="user-meta">
          <div class="user-meta-form">
            <div>
              <mat-form-field>
                <input type="text" required placeholder="User ID" matInput formControlName="userId" i18n-placeholder>
              </mat-form-field>
              <mat-form-field>
                <input type="text" required placeholder="Display Name" matInput formControlName="displayName" i18n-placeholder>
              </mat-form-field>
              <mat-form-field>
                <input type="text" required placeholder="Email" matInput formControlName="email" i18n-placeholder>
              </mat-form-field>
            </div>
            <div>
              <mat-form-field>
                <input type="text" required placeholder="First Name" matInput formControlName="firstName" i18n-placeholder>
              </mat-form-field>
              <mat-form-field>
                <input type="text" required placeholder="Last Name" matInput formControlName="lastName" i18n-placeholder>
              </mat-form-field>
              <mat-form-field>
                <input type="text" required placeholder="Initials" matInput formControlName="initials" i18n-placeholder>
              </mat-form-field>
            </div>
            <div>
              <mat-form-field>
                <input type="text" required placeholder="Google UID" matInput formControlName="googleUid" i18n-placeholder>
              </mat-form-field>
              <mat-form-field>
                <mat-select placeholder="Roles" formControlName="type" multiple>
                  <mat-option *ngFor="let role of roles" [value]="role.id">{{role.id}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div>
              <mat-checkbox formControlName="active" i18n-placeholder>Active?</mat-checkbox>
            </div>
          </div>
        </div>        
      </div>
    </mat-card-content>
    <mat-card-actions>
      <button mat-raised-button type="submit" [disabled]="userForm.invalid || userAdding">
        <span *ngIf="editMode; else elseBlock" i18n>Update</span>
        <ng-template #elseBlock>
          <span i18n>Submit</span>
        </ng-template>
      </button>
      <a mat-raised-button [routerLink]="['/users']">
        <span i18n>Cancel</span>
      </a>
    </mat-card-actions>
  </form>
</mat-card>


// WEBPACK FOOTER //
// ./src/app/users/users-add/users-add.component.html